import {
  parseAndFormatPointsData,
  groupCategories,
  sortObjectAlphabatecially
} from '../../../Services/UtilService/UtilService';

import * as types from '../../Types';

const initialState = {
  employeeData: [],
  headerData: [],
  leaderboardData: [],
  selectedEmployee: {},
  selectedCategory: {},
  categoryList: [],
  appreciationList: [],
  appreciationTransactionList: [],
  pbBalanceList: [],
  roles: [],
  permissions: [],
  loading: null,
  error: ''
};

const EmployeeRewardsReducer = (state = initialState, action) => {
  let result;

  switch (action.type) {
    case types.LOAD_PROFILE_DATA:
      return {
        ...state,
        headerData: [],
        loading: true,
        error: ''
      };

    case types.LOAD_PROFILE_DATA_SUCCESS: {
      result = action.result || [];
      return {
        ...state,
        headerData: result,
        loading: false
      };
    }

    case types.LOAD_EMPLOYEE_LIST:
    case types.UPDATE_ROLE:
    case types.FETCH_ROLE_PERMISSIONS:
    case types.FETCH_PERMISSIONS:
    case types.ADD_ROLE:
    case types.DELETE_ROLE:
    case types.ADD_REWARD:
    case types.APPRECIATE:
    case types.ADD_EMPLOYEE:
    case types.ADD_CATEGORY:
    case types.UPDATE_CATEGORY:
    case types.REMOVE_CATEGORY:
    case types.REMOVE_EMPLOYEE:
    case types.UPDATE_EMPLOYEE:
      return {
        ...state,
        loading: true,
        error: ''
      };

    case types.LOAD_EMPLOYEE_LIST_SUCCESS: {
      result = action.result || [];
      return {
        ...state,
        employeeData: result,
        loading: false
      };
    }

    case types.LOAD_CATEGORIES_LIST:
      return {
        ...state,
        categoryList: [],
        loading: true,
        error: ''
      };

    case types.LOAD_CATEGORIES_LIST_SUCCESS: {
      result = action.result || [];
      return {
        ...state,
        categoryList: result,
        loading: false
      };
    }

    case types.LOAD_LEADERBOARD_DATA:
      return {
        ...state,
        leaderboardData: [],
        loading: true,
        error: ''
      };

    case types.LOAD_LEADERBOARD_DATA_SUCCESS: {
      result = action.result || [];
      return {
        ...state,
        leaderboardData: result,
        loading: false
      };
    }

    case types.LOAD_CHECKPOINT_DATA:
      return {
        ...state,
        checkpointData: {},
        loading: true,
        error: ''
      };

    case types.LOAD_CHECKPOINT_DATA_SUCCESS: {
      result = action.result || {};
      return {
        ...state,
        checkpointData: result,
        loading: false
      };
    }

    case types.LOAD_UPCOMING_REWARDS_LIST:
      return {
        ...state,
        upcomingRewardsData: [],
        loading: true,
        error: ''
      };

    case types.LOAD_UPCOMING_REWARDS_LIST_SUCCESS: {
      result = action.result || [];
      return {
        ...state,
        upcomingRewardsData: result,
        loading: false
      };
    }

    case types.ADD_EMPLOYEE_SUCCESS:
    case types.ADD_REWARD_SUCCESS:
    case types.ADD_CATEGORY_SUCCESS:
    case types.REMOVE_REWARD_SUCCESS:
    case types.UPDATE_CATEGORY_SUCCESS:
    case types.REMOVE_CATEGORY_SUCCESS:
    case types.REMOVE_EMPLOYEE_SUCCESS:
    case types.UPDATE_EMPLOYEE_SUCCESS:
    case types.APPRECIATE_SUCCESS:
    case types.REDEEM_REWARD_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case types.CLEAR_EMPLOYEE_LIST:
      return {
        ...state,
        employeeData: []
      };

    case types.HIGHLIGHT_EMPLOYEE:
    case types.LOAD_REWARDS_LIST:
      result = action.payload || { name: '', id: '?' };
      return {
        ...state,
        selectedEmployee: result,
        loading: action.type === types.LOAD_REWARDS_LIST,
        error: ''
      };

    case types.LOAD_REWARDS_LIST_SUCCESS: {
      result = action.result || [];
      const pointsList = parseAndFormatPointsData(result, state.employeeData);

      const categoryCounts = groupCategories(result);
      const sortedCategoryCount = sortObjectAlphabatecially(categoryCounts);
      return {
        ...state,
        selectedEmployee: {
          ...state.selectedEmployee,
          pointsList,
          categoryCounts: sortedCategoryCount
        },
        loading: false
      };
    }

    case types.UNHIGHLIGHT_EMPLOYEE:
    case types.CLEAR_REWARDS_LIST:
      return {
        ...state,
        selectedEmployee: {}
      };

    case types.CLEAR_EMPLOYEE_REWARDS_ERROR:
      return {
        ...state,
        error: ''
      };

    case types.REMOVE_REWARD:
    case types.REDEEM_REWARD: {
      return {
        ...state,
        loading: true
      };
    }

    case types.LOAD_APPRECIATION_LIST:
      return {
        ...state,
        appreciationList: [],
        loading: true,
        error: ''
      };

    case types.LOAD_APPRECIATION_LIST_SUCCESS: {
      result = action.result;
      const parsedAppreciationList = parseAndFormatPointsData(result, state.employeeData);
      return {
        ...state,
        appreciationList: parsedAppreciationList,
        loading: false
      };
    }

    case types.LOAD_APPRECIATION_TRANSACTION_LIST:
      return {
        ...state,
        appreciationTransactionList: [],
        loading: true,
        error: ''
      };

    case types.LOAD_APPRECIATION_TRANSACTION_LIST_SUCCESS: {
      result = action.result;
      const parsedAppreciationTransactionList = parseAndFormatPointsData(
        result,
        state.employeeData,
        true
      );
      return {
        ...state,
        appreciationTransactionList: parsedAppreciationTransactionList,
        loading: false
      };
    }

    case types.LOAD_PIGGY_BANK_BALANCE_LIST:
      return {
        ...state,
        pbBalanceList: [],
        loading: true,
        error: ''
      };

    case types.LOAD_PIGGY_BANK_BALANCE_LIST_SUCCESS: {
      result = action.result;
      const parsedPiggyBankList = result.map(res => ({
        pbBalance: res.pb_balance,
        ...res.employee
      }));
      return {
        ...state,
        pbBalanceList: parsedPiggyBankList,
        loading: false
      };
    }

    case types.HIGHLIGHT_CATEGORY:
      result = action.payload;
      return {
        ...state,
        selectedCategory: result
      };

    case types.UNHIGHLIGHT_CATEGORY:
      return {
        ...state,
        selectedCategory: {}
      };

    case types.APPRECIATE_FAILURE:
    case types.ADD_REWARD_FAILURE: {
      const errorMessage =
        action?.error?.message ||
        action?.error?.response?.data?.message ||
        action?.payload?.response?.data?.message ||
        (typeof action?.error?.response?.data === 'string'
          ? action.error.response.data
          : undefined);
      return {
        ...state,
        loading: false,
        error: errorMessage
      };
    }

    case types.REMOVE_REWARD_FAILURE:
    case types.LOAD_REWARDS_LIST_FAILURE:
    case types.REMOVE_EMPLOYEE_FAILURE:
    case types.ADD_EMPLOYEE_FAILURE:
    case types.ADD_CATEGORY_FAILURE:
    case types.UPDATE_CATEGORY_FAILURE:
    case types.REMOVE_CATEGORY_FAILURE:
    case types.LOAD_CATEGORIES_LIST_FAILURE:
    case types.LOAD_EMPLOYEE_LIST_FAILURE:
    case types.LOAD_APPRECIATION_LIST_FAILURE:
    case types.LOAD_APPRECIATION_TRANSACTION_LIST_FAILURE:
    case types.LOAD_LEADERBOARD_DATA_FAILURE:
    case types.LOAD_PROFILE_DATA_FAILURE:
    case types.LOAD_CHECKPOINT_DATA_FAILURE:
    case types.LOAD_UPCOMING_REWARDS_LIST_FAILURE:
    case types.REDEEM_REWARD_FAILURE:
    case types.UPDATE_EMPLOYEE_FAILURE:
    case types.LOAD_PIGGY_BANK_BALANCE_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error?.message
      };
    }

    case types.DESTROY_SESSION:
      return {
        ...initialState
      };

    case types.FETCH_ROLE_PERMISSIONS_SUCCESS: {
      result = action.result;
      return {
        ...state,
        roles: result.roles,
        loading: false,
        error: ''
      };
    }

    case types.FETCH_ROLE_PERMISSIONS_FAILURE:
      return {
        ...state,
        roles: [],
        loading: false,
        error: action.error
      };

    case types.FETCH_PERMISSIONS_SUCCESS: {
      result = action.result;
      return {
        ...state,
        permissions: result.permissions,
        loading: false,
        error: ''
      };
    }

    case types.FETCH_PERMISSIONS_FAILURE:
      return {
        ...state,
        permissions: [],
        loading: false,
        error: action.error
      };
    case types.ADD_ROLE_SUCCESS: {
      result = action.result;
      return {
        ...state,
        roles: [...state.roles, result],
        loading: false,
        error: ''
      };
    }
    case types.ADD_ROLE_FAILURE:
    case types.UPDATE_ROLE_FAILURE:
    case types.DELETE_ROLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case types.DELETE_ROLE_SUCCESS: {
      const deletedRoleId = action.roleId;
      return {
        ...state,
        roles: state.roles.filter(role => role.id !== deletedRoleId),
        loading: false,
        error: ''
      };
    }

    case types.UPDATE_ROLE_SUCCESS: {
      const updatedRole = action.result;
      const updatedRoles = state.roles.map(role =>
        role.id === updatedRole.id ? updatedRole : role
      );
      return {
        ...state,
        roles: updatedRoles,
        loading: false,
        error: ''
      };
    }

    default:
      return state;
  }
};

export default EmployeeRewardsReducer;
